import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardLayoutComponent } from './components/layouts/dashboard/dashboard-layout.component';
import { FullpageLayoutComponent } from './components/layouts/fullpage/fullpage-layout.component';
import { AuthGuard } from './shared/helpers/auth.guard';
import { ChangePasswordComponent } from './components/login/change-password/change-password.component';
import { UserProfileComponent } from './components/login/user-profile/user-profile.component';
//import { ElevatorCallComponent } from './components/elevator-call/elevator-call.component';
import { DataAlarmsComponent } from './components/data-alarms/data-alarms.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  }, 
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./components/data-alarms/data-alarms.module').then(m => m.DataAlarmsModule)
      }
    ]
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./components/failed-calls/failed-calls.module').then(m => m.FailedCallsModule)
      }
    ]
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // {
      //   path: 'elevatorcall',
      //   component: ElevatorCallComponent,
      //   //canActivate: [AuthGuard],
      //   pathMatch: 'full'
      // },
      {
        path: '',
        loadChildren: () => import('./components/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: '',
        loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: '',
        loadChildren: () => import('./components/elevator-call/elevator-call.module').then(m => m.ElevatorCallModule)
      },
      {
        path: '',
        loadChildren: () => import('./components/login/customers/customers.module').then(m => m.CustomersModule)
      },
      {
        path: '',
        loadChildren: () => import('./components/logs/logs.module').then(m => m.LogsModule)
      },
      { path: 'change-pwd', component: ChangePasswordComponent, canActivate: [AuthGuard] },
      {
        path: '',
        loadChildren: () => import('./components/search/search.module').then(m => m.SearchModule)
      }
    ]
  },
  {
    path: '',
    component: FullpageLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./components/login/account.module').then(m => m.AccountModule)
      },
      {
        path: 'screenpop',
        loadChildren: () => import('./components/screenpop/screenpop.module').then(m => m.ScreenPopModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'avaya-calls',
  }
]
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
